import { useRef } from 'react'
import { createFoodSafetySubmissionKeys } from 'src/utils/foodSafetySaveGuard'

/** One set of `POST /logs` duplicate-save keys per mounted screen (72). */
export default function useFoodSafetySubmissionKeys() {
  const ref = useRef(null)
  if (!ref.current) ref.current = createFoodSafetySubmissionKeys()
  return ref.current
}
